import React from "react";
import { SvgIcon } from "@mui/material";
import socialLinkIconStyles from "../../icons/socialLinkIconStyles";

const XLogoIcon = ({ color }: any) => {
  return (
    <SvgIcon sx={socialLinkIconStyles(color)}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 7C10.5523 7 11 7.44772 11 8V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H12C11.2043 17 10.4413 16.6839 9.87868 16.1213C9.31607 15.5587 9 14.7956 9 14V8C9 7.44772 9.44772 7 10 7Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92894 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121 8.17316C3.51809 6.3459 4.79981 4.78412 6.4443 3.6853ZM12 4C10.4178 4 8.87104 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM9 11C9 10.4477 9.44772 10 10 10H13C13.5523 10 14 10.4477 14 11C14 11.5523 13.5523 12 13 12H10C9.44772 12 9 11.5523 9 11Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default XLogoIcon;